import { render } from "./Invoices.vue?vue&type=template&id=7ef3f53c&scoped=true&ts=true"
import script from "./Invoices.vue?vue&type=script&lang=ts"
export * from "./Invoices.vue?vue&type=script&lang=ts"

import "./Invoices.vue?vue&type=style&index=0&id=7ef3f53c&lang=scss&scoped=true"

import exportComponent from "/home/issa/hcpet/hcpet-kasse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ef3f53c"]])

export default __exports__